import styled from "styled-components";

/* Figma card: border #E0E0E0, radius 8px, padding 24px, white bg */
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 200px;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  border: 1px solid var(--slate-200, #E2E8F0);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

/* Figma: icon 24px, margin-bottom 16px */
export const WidgetHead = styled.div`
  flex-shrink: 0;
  margin-bottom: 12px;
`;

/* Figma: 18px, 600, #2F2F2F, line-height 24px, margin-bottom 8px */
export const WidgetTitle = styled.h1`
  margin: 0 0 8px 0;
  padding: 0;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0;
  color: #2F2F2F;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* Figma: 14px, 400, #6C6C6C, line-height 20px, margin-bottom 24px */
export const WidgetContent = styled.label`
  margin: 0 0 24px 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: #475569;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;